<template>
  <div class="col">
    <transition name="card">
      <div v-if="item.isOpen === true" class="openCard">
        <div class="card-body">
          <div class="card-body__back">
            <div class="container">
          <span class="link" @click="close()">
            <router-link :to=" { name: 'Home' } ">Главная</router-link>
          </span>
              <span> / </span>
              <span class="link" @click="close()">
            <router-link :to=" { name: 'Blog' } ">Блог</router-link>
          </span>
              <span> / </span>
              <span>{{ item.title }}</span>
            </div>
          </div>
          <div class="card-body__content">
            <div class="container">
              <h3>Наш блог</h3>
              <h4>{{ item.title }}</h4>
              <p>{{ item.text_1 }}</p>
              <div class="image">
                <picture>
                  <source v-bind:srcset=item.srcset_3>
                  <img v-bind:src=item.src_3 alt="">
                </picture>
              </div>
              <p>{{ item.text_2 }}</p>
              <div class="row">
                <div class="col-5">
                  <picture>
                    <source v-bind:srcset=item.srcset_1>
                    <img v-bind:src=item.src_1 alt="">
                  </picture>
                </div>
                <div class="col-5">
                  <picture>
                    <source v-bind:srcset=item.srcset_2>
                    <img v-bind:src=item.src_2 alt="">
                  </picture>
                </div>
              </div>
              <p>{{ item.text_3 }}</p>
              <div class="image">
                <picture>
                  <source v-bind:srcset=item.srcset_4>
                  <img v-bind:src=item.src_4 alt="">
                </picture>
              </div>
              <div class="information">
                <span>Автор: {{ item.author }}</span>
                <small>{{ item.date }}</small>
              </div>
            </div>
          </div>
          <SectionRequest/>
        </div>
      </div>
    </transition>
    <div class="col-body">
      <div class="col-body__img">
        <div class="col-body__date">
          {{ item.date }}
        </div>
        <picture>
          <source v-bind:srcset=item.srcset_1>
          <img v-bind:src=item.src_1 alt="">
        </picture>
      </div>
      <div class="col-body__info">
        <h4 class="col-body__title">
          {{ item.title }}
        </h4>
        <button class="col-body__button button__transparent button_small" @click="openCard ()">Читать полностью</button>
      </div>
    </div>
  </div>
</template>

<script>
import SectionRequest from "@/components/SectionRequest";
import {mapActions} from "vuex";
export default {
  name: 'BlogItem',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  components: {
    SectionRequest
  },
  methods: {
    openCard () {
      this.item.isOpen = true
      document.body.style.overflow = 'hidden';
    },
    ...mapActions([
      'closeArticle'
    ]),
    close () {
      this.closeArticle()
    }
  },
  mounted() {
  },
  beforeDestroy() {
    this.close()
  }
}
</script>

<style scoped lang='scss'>
.col {
  flex: 0 0 50%;
  max-width: 50%;
  padding: 0 40px;
  margin-bottom: 60px;
  @media (max-width: 997.98px) {
    flex: 0 0 100%;
    max-width: 100%;
  }
  &-body {
    box-sizing: border-box;
    overflow: hidden;
    &__date {
      position: absolute;
      bottom: 0;
      left: 0;
      padding: 2rem 4rem;
      background-color: #eee;
      font-size: 1.8rem;
    }
    &__img {
      position: relative;
      width: 100%;
      height: 100%;
      @media (max-width: 997.98px) {
        height: 300px;
      }
      img {
        height: 100%;
        width: 100%;
        object-fit: cover;
        object-position: center;
      }
    }
    &__title {
      font-weight: normal;
      font-size: 2rem;
      margin: 40px 0 20px 0;
    }
    &__button {
      font-size: 1.6rem;
      font-weight: 300;
      padding: 14px 30px;
    }
  }
}
.openCard {
  position: fixed;
  background-color: #eee;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 20;
  padding-top: 60px;
  @media (max-width: 1399.98px) {
    padding-top: 57px;
  }
  @media (max-width: 997.98px) {
    overflow-x: hidden;
  }
  .card-body {
    width: 100%;
    height: 100%;
    position: relative;
    overflow-y: auto;
    @media (max-width: 997.98px) {
      overflow-x: hidden;
    }
    &__back {
      padding: 20px;
      .link {
        a {
          transition: .1s linear all;
        }
        &:hover {
          a {
            color: #eb5757;
          }
        }
      }
    }
    h3 {
      font-weight: 500;
      font-size: 4rem;
      margin-bottom: 30px;
    }
    h4 {
      font-weight: normal;
      font-size: 3rem;
      max-width: 600px;
    }
    p {
      font-weight: 300;
      font-size: 2rem;
      color: #4F4F4F;
      margin: 40px 0;
    }
    .image {
      position: relative;
      width: 100%;
      height: 100%;
      overflow: hidden;
      box-sizing: border-box;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
      }
    }
    .row {
      display: flex;
      flex-wrap: wrap;
      margin: 0 -30px;
      .col-5 {
        flex: 0 0 50%;
        max-width: 50%;
        box-sizing: border-box;
        overflow: hidden;
        padding: 0 30px;
        height: 700px;
        @media (max-width: 997.98px) {
          flex: 0 0 100%;
          max-width: 100%;
          height: 300px;
          margin-bottom: 30px;
          &:last-child {
            margin-bottom: 0;
          }
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
        }
      }
    }
    .information {
      margin-top: 50px;
      display: flex;
      flex-direction: column;
      span {
        font-size: 1.8rem;
        color: #333333;
        margin-bottom: 10px;
      }
      small {
        font-size: 1.4rem;
        font-weight: 300;
        color: #4F4F4F;
      }
    }
  }
}
.card-enter-active, .card-leave-active {
  transition: opacity .5s;
}
.card-enter, .card-leave-to {
  opacity: 0;
}
</style>
